import { Card } from "@/components/ui/card";
import type { CLOCK_CADENCE } from "@/providers/wall-clock";
import type { DashboardSpec } from "./ChartSpec";
import { DataViewerProvider } from "./data-viewer-provider";
import { PanelStack } from "./panels/panel-stack";
import { SpecProvider } from "./spec/spec-context";
import { AutoRefreshTicker } from "./time-window/auto-refresh-ticker";
import { LastUpdatedBar } from "./time-window/last-updated-bar";
import { WindowRangePicker } from "./time-window/window-range-picker";

function DataViewerMessage({ message }: { message: string }) {
    return (
        <Card>
            <div className={"text-muted-foreground text-sm text-center"}>{message}</div>
        </Card>
    );
}

export function DataViewer({
    initialSpec,
    isLoading,
    isError,
    isEmpty,
    autoRefreshCadence,
}: {
    initialSpec: DashboardSpec;
    isLoading?: boolean;
    isError?: boolean;
    isEmpty?: boolean;
    autoRefreshCadence?: CLOCK_CADENCE;
}) {
    if (isLoading) {
        return <DataViewerMessage message={"Loading data streams..."} />;
    }
    if (isError) {
        return <DataViewerMessage message={"Failed to load data streams."} />;
    }
    if (isEmpty) {
        return <DataViewerMessage message={"No data streams for this zone."} />;
    }

    return (
        <SpecProvider initialSpec={initialSpec}>
            <DataViewerProvider defaultTimeRange={initialSpec.defaultTimeRange}>
                <div className={"flex ml-[42px] mb-3 gap-2 items-center justify-between"}>
                    <WindowRangePicker />
                    {autoRefreshCadence != null && (
                        <>
                            <AutoRefreshTicker cadence={autoRefreshCadence} />
                            <LastUpdatedBar />
                        </>
                    )}
                </div>
                <PanelStack />
            </DataViewerProvider>
        </SpecProvider>
    );
}
